// extracted by mini-css-extract-plugin
module.exports = {"blue":"#6387C5","lightBlue":"rgb(207, 216, 231)","smoke":"rgb(186, 191, 189)","brand":"rgb(6, 127, 111)","errorRed":"rgb(204, 61, 63)"};